export default {
  'cookie-banner:title': 'Bevor du weitershoppst…',
  'cookie-banner:subtitle':
    'Pets Deli verwendet Cookies, um dir den bestmöglichen Service zu gewährleisten. Mit der Nutzung der Seite stimmst du der Cookie-Nutzung zu.',
  'cookie-banner:privacy-text':
    'Auf der Seite { privacyProtectionLink } kannst du jederzeit nachlesen, wie und wofür wir deine Daten verwenden.',
  'cookie-banner:privacy-link': 'Datenschutz',
  'cookie-banner:button': 'Okay, weiter zum Shop',
};
